import { createFileRoute, redirect } from '@tanstack/react-router'

// A legacy inbound URL for the article that now lives under /learn.
export const Route = createFileRoute('/thai-dictionary-designed-for-learners-of-thai')({
   beforeLoad: () => {
      throw redirect({
         to: '/learn/$blogSlug',
         params: { blogSlug: 'thai-dictionary-designed-for-learners-of-thai' },
      })
   },
})
